module.exports = __webpack_public_path__ + "img/Contactus.00b37b91.png";